import {UserCreationErrors} from "./create-username-password-page";
import { FORM_ERROR } from 'final-form'

export const handleCreateUserErrors = (t, errors: UserCreationErrors) => {
    const UserCreationErrorsMap = {
        // parent
        'too_young': t('user_creation_error_too_young', 'Parent must be 18 or older'),
        'too_many': t('user_creation_error_too_many', 'Parent has already reach the hard limit for their account'),
        'not_verified': t('user_creation_error_not_verified', 'Parent needs to be verified in some way for thier country to create a child account.'),

        // country_code
        'missing_country_code': t('user_creation_error_missing_country_code', 'Must provide country code.'),
        'invalid_country_code': t('user_creation_error_invalid_country_code', 'Not a country code we support.'),
        'match_parent': t('user_creation_error_match_parent', 'Request has bearer auth for creating a child account, but country code does not match parent\'s country code.'),

        // date_of_birth
        'missing_dob': t('user_creation_error_missing_dob', 'Must provide date of birth.'),
        'invalid_birthday': t('user_creation_error_invalid_birthday','Not a valid birthday.'),
        'invalid_country_dob': t('user_creation_error_invalid_country_dob', 'Country must be valid to validate date of birth.'),
        'under_aoc': t('user_creation_error_under_aoc', 'Date of birth puts user under the age of consent and the request does not have bearer auth for creating a child account.'),
        'child_too_old': t('user_creation_error_child_too_old', 'User over the age of consent cannot be a child user'),

        // email
        'missing_email': t('user_creation_error_missing_email', 'Must provide email.'),
        'invalid_email': t('user_creation_error_invalid_email', 'Email is obviously not valid.'),
        'not_allowed': t('user_creation_error_not_allowed_email', 'Email is denied or not deliverable.'),
        'in_use_email': t('user_creation_error_in_use_email', 'Email is already used by someone else.'),

        // username
        'missing_username': t('user_creation_error_missing_username', 'Must provide username.'),
        'min_length_username': t('user_creation_error_min_length_username', 'Username is less than 6 characters.'),
        'max_length_username': t('user_creation_error_max_length_username', 'username is more than 16 characters.'),
        'invalid_characters_username': t('user_creation_error_invalid_chars_username', 'Username contains invalid characters.'),
        'in_use_username': t('user_creation_error_in_use_username', 'Username is already used by someone else.'),

        // screen_name
        'missing_screen_name': t('user_creation_error_missing_screen_name', 'Must provide a screen name'),
        'min_length_screen_name': t('user_creation_error_min_length_screen_name', 'Screen name is less than 6 characters.'),
        'max_length_screen_name': t('user_creation_error_max_length_screen_name', 'Screen name is more than 15 characters.'),
        'invalid_chars_screen_name': t('user_creation_error_invalid_chars_screen_name', 'Screen name contains invalid characters.'),
        'not_clean': t('user_creation_error_not_clean_screen_name', 'Screen name doesn\'t pass clean speak check.'),
        'in_use_screen_name': t('user_creation_error_in_use_screen_name', 'Screen name is already used by someone else.'),

        // password
        'missing_password': t('user_creation_error_missing_password', 'Must provide password.'),
        'min_length_password': t('user_creation_error_min_length_password', 'Password is less than 8 characters.'),
        'max_length_password': t('user_creation_error_max_length_password', 'Password is more than 15 characters.'),
        'too_simple_password': t('user_creation_error_too_simple_password', 'Password requires a lowercase letter, uppercase letter, digit, or symbol.'),
        'invalid_char_password': t('user_creation_error_invalid_char_password', 'Password contains wide unicode characters.'),

        // email opt in
        'missing_email_opt_in': t('user_creation_error_missing_email_opt_in', 'Must provide Email opt in.'),
        'child_email_opt_in': t('user_creation_error_child_email_opt_in', 'Must be false or omitted for child accounts.'),

        // email opt in pcenter
        'missing_email_opt_in_pcenter': t('user_creation_error_missing_email_opt_in_pcenter', 'Must provide Email opt in pcenter.'),
        'child_email_opt_in_pcenter': t('user_creation_error_child_email_opt_in_pcenter', 'Must be false or omitted for child accounts.'),

        // terms
        'missing_terms': t('user_creation_error_missing_terms', 'Must provide Terms of Use.'),
        'invalid_terms': t('user_creation_error_invalid_terms', 'Terms of Use must be true.'),

        // privacy notice
        'missing_privacy': t('user_creation_error_missing_privacy', 'Must provide Privacy Notice.'),
        'invalid_privacy': t('user_creation_error_invalid_privacy', 'Privacy Notice must be true.'),
    }

    if (Object.keys(errors)?.includes('username')) {
        if (errors['username'].includes('in_use')) {
            return { username: UserCreationErrorsMap['in_use_username'] }
        } else if (errors['username'].includes('missing')) {
            return { username: UserCreationErrorsMap['missing_username'] }
        } else if (errors['username'].includes('min_length')) {
            return { username: UserCreationErrorsMap['min_length_username'] }
        } else if (errors['username'].includes('max_length')) {
            return { username: UserCreationErrorsMap['max_length_username'] }
        } else if (errors['username'].includes('invalid_characters')) {
            return { username: UserCreationErrorsMap['invalid_characters_username'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else if (Object.keys(errors)?.includes("password")) {
        if (errors['password'].includes('missing')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['missing_password'] }
        } else if (errors['password'].includes('min_length')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['min_length_password'] }
        } else if (errors['password'].includes('max_length')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['max_length_password'] }
        } else if (errors['password'].includes('too_simple')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['too_simple_password'] }
        } else if (errors['password'].includes('invalid_characters')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['invalid_char_password'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else if (Object.keys(errors)?.includes("country_code")) {
        if (errors['country_code'].includes('missing')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['missing_country_code'] }
        } else if (errors['country_code'].includes('invalid')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['invalid_country_code'] }
        } else if (errors['country_code'].includes('match_parent')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['match_parent'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else if (Object.keys(errors)?.includes("date_of_birth")) {
        if (errors['date_of_birth'].includes('missing')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['missing_dob'] }
        } else if (errors['date_of_birth'].includes('invalid')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['invalid_birthday'] }
        } else if (errors['date_of_birth'].includes('invalid_country')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['invalid_country_dob'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else if (Object.keys(errors)?.includes("email")) {
        if (errors['email'].includes('missing')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['missing_email'] }
        } else if (errors['email'].includes('invalid')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['invalid_email'] }
        } else if (errors['email'].includes('not_allowed')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['not_allowed'] }
        } else if (errors['email'].includes('in_use')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['in_use_email'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else if (Object.keys(errors)?.includes("screen_name")) {
        if (errors['screen_name'].includes('missing')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['missing_screen_name'] }
        } else if (errors['screen_name'].includes('min_length')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['min_length_screen_name'] }
        } else if (errors['screen_name'].includes('max_length')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['max_length_screen_name'] }
        } else if (errors['screen_name'].includes('invalid_characters')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['invalid_chars_screen_name'] }
        } else if (errors['screen_name'].includes('not_clean')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['not_clean'] }
        } else if (errors['screen_name'].includes('in_use')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['in_use_screen_name'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else if (Object.keys(errors)?.includes("email_opt_in")) {
        if (errors['email_opt_in'].includes('missing')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['missing_email_opt_in'] }
        } else if (errors['email_opt_in'].includes('child')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['child_email_opt_in'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else if (Object.keys(errors)?.includes("email_opt_in_pcenter")) {
        if (errors['email_opt_in_pcenter'].includes('missing')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['missing_email_opt_in_pcenter'] }
        } else if (errors['email_opt_in_pcenter'].includes('child')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['child_email_opt_in_pcenter'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else if (Object.keys(errors)?.includes("terms")) {
        if (errors['terms'].includes('missing')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['missing_terms'] }
        } else if (errors['terms'].includes('invalid')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['invalid_terms'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else if (Object.keys(errors)?.includes("privacy_notice")) {
        if (errors['privacy_notice'].includes('missing')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['missing_privacy'] }
        } else if (errors['privacy_notice'].includes('invalid')) {
            return { [FORM_ERROR]: UserCreationErrorsMap['invalid_privacy'] }
        } else {
            return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
        }
    } else {
        return { [FORM_ERROR]: t('unexpected_error', 'An unexpected error occurred. Please contact Customer support')}
    }
}
